import axios from 'axios';
const url = 'https://api.app-lab.be-keeper.com/partners';
// const url = `${process.env.API}/partners`;

//Partners routes
export const fetchPartners = () => axios.get(url);
export const createPartners = (newPartner) => axios.post(url, newPartner);
export const updatePartner = (id, updatedPartner) => axios.patch(`${url}/${id}`, updatedPartner);
export const deletePartner = (id) => axios.delete(`${url}/${id}`);